<template>
    <card
        background="warning-05"
        borderColor="transparent"
        class="wp-10 fs-3 p-4 mb-6 subscription-summary"
    >
        <div class="flex-row jc-space" :class="{ 'mb-3 pb-3 bb-1-gray-40': isRenew && isSales }">
            <div>
                <h2 class="bold m-0 mb-3">{{ $l10n.__('Abonnement en cours') }}</h2>
                <p class="fs-3 mb-3 flex-row flex-bottom">
                    <SaasIcon icon="SvgLogoSellsyCloud" width="23" height="17" class="gray-100" />
                    <span v-if="isLatestPricingVersion" class="capitalize ml-1"
                        >Sellsy {{ previousCurrentPlanLabel }}</span
                    >
                    <span v-else class="capitalize ml-1"
                        >Pricing V{{ previousPricingVersion }}</span
                    >
                </p>
                <!-- V4 Licences Resumes -->
                <ul v-if="isLatestPricingVersion" class="my-0">
                    <li
                        v-for="(product, index) in previousProductsWithLicences"
                        :key="product.code"
                        class="flex-row"
                        :class="{ 'mb-2': index !== previousProductsWithLicences.length - 1 }"
                    >
                        <div>
                            <p class="mb-1 mt-0 fs-3">
                                {{
                                    $l10n.n__(
                                        '%(total)s licence %(productsName)s',
                                        '%(total)s licences %(productsName)s',
                                        previousProducts[product.id].quantity,
                                        {
                                            total: previousProducts[product.id].quantity,
                                            productsName: product.title,
                                        },
                                    )
                                }}
                            </p>
                            <span v-if="previousFreeLicencesByProduct(product.id)" class="fs-2">{{
                                $l10n.n__(
                                    'Dont %s offerte',
                                    'Dont %s offertes',
                                    previousFreeLicencesByProduct(product.id),
                                    previousFreeLicencesByProduct(product.id),
                                )
                            }}</span>
                        </div>
                    </li>
                    <li
                        v-for="(product, index) in previousPacksWithLicences"
                        :key="product.code"
                        class="flex-row"
                        :class="{
                            'mb-2': index !== previousPacksWithLicences.length - 1,
                            'mt-2': index === 0,
                        }"
                    >
                        <div>
                            <p class="mb-0 mt-0 fs-3">
                                {{
                                    $l10n.__('Module %(productsName)s', {
                                        productsName: !!product.groups.length
                                            ? product.printableName
                                            : product.title,
                                    })
                                }}
                            </p>
                        </div>
                    </li>
                </ul>
                <!-- V3 Pack Resume -->
                <ul v-else-if="previousPricingVersion === 3" class="my-0">
                    <!-- Pack CRM -->
                    <li v-if="previousSubcribedProducts.pack_crm" class="mb-2 flex-row">
                        <div>
                            <p class="m-0 fs-3 lh-20">
                                {{
                                    $l10n.n__(
                                        '%(total)d utilisateur %(productsName)s',
                                        '%(total)d utilisateurs %(productsName)s',
                                        4,
                                        {
                                            total: previousSubcribedProducts.pack_crm
                                                .customerLicense.quantitySubscribed,
                                            productsName: previousSubcribedProducts.pack_crm.title,
                                        },
                                    )
                                }}
                            </p>
                            <span
                                v-if="
                                    !!previousSubcribedProducts.pack_crm.productPlan
                                        .customPricing &&
                                    previousSubcribedProducts.pack_crm.productPlan.customPricing[0]
                                        .unit_amount === 0
                                "
                                class="fs-2"
                            >
                                {{
                                    $l10n.n__(
                                        'Dont %s offerte',
                                        'Dont %s offertes',
                                        previousSubcribedProducts.pack_crm.productPlan
                                            .customPricing[0].up_to,
                                        previousSubcribedProducts.pack_crm.productPlan
                                            .customPricing[0].up_to,
                                    )
                                }}
                            </span>
                        </div>
                    </li>
                    <!-- Pack Invoicing -->
                    <li v-if="!!previousSubcribedProducts.pack_invoicing" class="mb-2 flex-row">
                        <div>
                            <p class="m-0 fs-3 lh-20">
                                {{ $l10n.__('Module') }}
                                {{ previousSubcribedProducts.pack_invoicing.title }}
                            </p>
                            <span
                                v-if="
                                    !!previousSubcribedProducts.pack_invoicing.productPlan
                                        .customPricing &&
                                    previousSubcribedProducts.pack_invoicing.productPlan
                                        .customPricing[0].unit_amount === 0
                                "
                                class="fs-2"
                            >
                                {{ $l10n.__('Offert') }}
                            </span>
                        </div>
                    </li>
                    <!-- Pack Managment -->
                    <li v-if="!!previousSubcribedProducts.pack_management" class="mb-2 flex-row">
                        <div>
                            <p class="m-0 fs-3 lh-20">
                                {{ $l10n.__('Module') }}
                                {{ previousSubcribedProducts.pack_management.title }}
                            </p>
                            <span
                                v-if="
                                    !!previousSubcribedProducts.pack_management.productPlan
                                        .customPricing &&
                                    previousSubcribedProducts.pack_management.productPlan
                                        .customPricing[0].unit_amount === 0
                                "
                                class="fs-2"
                            >
                                {{ $l10n.__('Offert') }}
                            </span>
                        </div>
                    </li>
                    <!-- Pack Stock -->
                    <li v-if="!!previousSubcribedProducts.pack_stock" class="mb-2 flex-row">
                        <div>
                            <p class="m-0 fs-3 lh-20">
                                {{ $l10n.__('Module') }}
                                {{ previousSubcribedProducts.pack_stock.title }}
                            </p>
                            <span
                                v-if="
                                    !!previousSubcribedProducts.pack_stock.productPlan
                                        .customPricing &&
                                    previousSubcribedProducts.pack_stock.productPlan
                                        .customPricing[0].unit_amount === 0
                                "
                                class="fs-2"
                            >
                                {{ $l10n.__('Offert') }}
                            </span>
                        </div>
                    </li>
                    <!-- Pack Support -->
                    <li v-if="!!previousSubcribedProducts.pack_support" class="mb-2 flex-row">
                        <div>
                            <p class="m-0 fs-3 lh-20">
                                {{ $l10n.__('Module') }}
                                {{ previousSubcribedProducts.pack_support.title }}
                            </p>
                            <span
                                v-if="
                                    !!previousSubcribedProducts.pack_support.productPlan
                                        .customPricing &&
                                    previousSubcribedProducts.pack_support.productPlan
                                        .customPricing[0].unit_amount === 0
                                "
                                class="fs-2"
                            >
                                {{ $l10n.__('Offert') }}
                            </span>
                        </div>
                    </li>
                </ul>
                <!-- Legacy Resume -->
                <p v-else class="gray-80">
                    {{ $l10n.__("Détails de l'abonnement indisponibles") }}
                </p>
            </div>
            <div class="aright">
                <div class="flex-row flex-right">
                    <div v-if="isSales || isPreviouslyYearly" class="fs-5 bold amount">
                        <span>
                            {{
                                $filters.numberFormatToFloatWithOptions(
                                    previousCart.total.yearly.total_amount_tax_included,
                                    numformat,
                                )
                            }}
                        </span>
                        <span class="fs-4 ml-1">
                            {{ numformat.currencysymbol }}
                        </span>
                        <span class="fs-3 mt-1">
                            {{ $l10n.__('/an') }}
                        </span>
                    </div>
                    <div v-if="isSales || isPreviouslyMonthly" class="fs-5 bold ml-4 amount">
                        <span
                            >{{
                                $filters.numberFormatToFloatWithOptions(
                                    previousCart.total.monthly.total_amount_tax_included,
                                    numformat,
                                )
                            }}
                        </span>
                        <span class="fs-4 ml-1">
                            {{ numformat.currencysymbol }}
                        </span>
                        <span class="fs-3">
                            {{ $l10n.__('/mois') }}
                        </span>
                    </div>
                </div>
                <div>
                    <p class="mb-0">{{ labelPlan }}</p>
                    <p class="fs-2 mt-1 mb-0">
                        {{
                            $l10n.__(
                                'Renouvellement le %s',
                                $filters.dateFormatter(
                                    previousCart.serviceEndDate,
                                    'SLASHED_DATE',
                                    false,
                                ),
                            )
                        }}
                    </p>
                    <p v-if="isSales" class="fs-2 mt-0">{{ leftDurationSubscription }}</p>
                </div>
                <div class="mt-3">
                    <span>{{ paymentMethodLabel }}</span>
                </div>
            </div>
        </div>
        <div v-if="isRenew && isSales">
            <h3 class="bold m-0 mb-2 lh-24">
                {{ $l10n.__('Utilisation de l’abonnement en cours') }}
            </h3>
            <p class="m-0 lh-20 fs-3 regular">{{ subscriptionUseLabel('nbActiveUsers') }}</p>
            <div class="flex-level">
                <template v-if="subscriptionUses.nbPermissionProfiles !== null">
                    <p class="fs-2 m-0 regular">
                        {{ subscriptionUseLabel('nbPermissionProfiles') }}
                    </p>
                </template>
                <template v-if="subscriptionUses.nbPipelines !== null">
                    <span class="px-2">|</span>
                    <p class="fs-2 m-0 regular">{{ subscriptionUseLabel('nbPipelines') }}</p>
                </template>
                <template v-if="subscriptionUses.nbCustomFields !== null">
                    <span class="px-2">|</span>
                    <p class="fs-2 m-0 regular">{{ subscriptionUseLabel('nbCustomFields') }}</p>
                </template>
                <template v-if="subscriptionUses.nbDunnings !== null">
                    <span class="px-2">|</span>
                    <p class="fs-2 m-0 regular">{{ subscriptionUseLabel('nbDunnings') }}</p>
                </template>
            </div>
        </div>
    </card>
</template>

<script>
import Card from 'vcomponents/Card.vue';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
        Card,
    },
    props: {
        context: {
            type: String,
            required: true,
            validator: (value) => ['upsell', 'renew'].includes(value),
        },
        isSales: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        isLatestPricingVersion() {
            return this.$store.getters[`${this.context}Cart/isLatestPricingVersion`];
        },
        previousCurrentPlan() {
            return this.$store.getters[`${this.context}Cart/previousCurrentPlan`];
        },
        previousPricingVersion() {
            return this.$store.getters[`${this.context}Cart/previousPricingVersion`];
        },
        previousProductsWithLicences() {
            return this.$store.getters[`${this.context}Cart/previousProductsWithLicences`];
        },
        previousPacksWithLicences() {
            return this.$store.getters[`${this.context}Cart/previousPacksWithLicences`];
        },
        previousProducts() {
            return this.$store.getters[`${this.context}Cart/previousProducts`];
        },
        previousFreeLicencesByProduct() {
            return this.$store.getters[`${this.context}Cart/previousFreeLicencesByProduct`];
        },
        previousSubcribedProducts() {
            return this.$store.getters[`${this.context}Cart/previousSubcribedProducts`];
        },
        previousCart() {
            return this.$store.getters[`${this.context}Cart/previousCart`];
        },
        paymentMethodLabel() {
            return this.$store.getters[`${this.context}Cart/paymentMethodLabel`];
        },
        numformat() {
            return this.$store.getters[`${this.context}Cart/numformat`];
        },
        labelPlan() {
            return this.isPreviouslyYearly
                ? this.$l10n.__('Abonnement annuel')
                : this.$l10n.__('Abonnement mensuel');
        },
        subscriptionUseLabel() {
            return this.$store.getters[`${this.context}Cart/subscriptionUseLabel`];
        },
        subscriptionUses() {
            return this.$store.getters[`${this.context}Cart/subscriptionUses`];
        },
        leftDurationSubscription() {
            const serviceEnd = moment(this.previousCart.serviceEndDate);
            const now = moment();
            const months = serviceEnd.diff(now, 'months');
            now.add(months, 'months');
            const days = serviceEnd.diff(now, 'days');

            return this.$l10n.__(`dans ${months} mois et ${days} jours`);
        },
        isPreviouslyMonthly() {
            return this.$store.getters[`${this.context}Cart/isPreviouslyMonthly`];
        },
        isPreviouslyYearly() {
            return this.$store.getters[`${this.context}Cart/isPreviouslyYearly`];
        },
        previousCurrentPlanLabel() {
            return this.$store.getters[`${this.context}Cart/previousCurrentPlanLabel`];
        },
        isRenew() {
            return this.$store.getters[`${this.context}Cart/isRenew`];
        },
    },
};
</script>
<style lang="scss" scoped>
.subscription-summary {
    max-width: 620px;
}
.amount {
    align-items: baseline;
    display: flex;
}
</style>
